<!-- 由 woniu6162 创建于 2019-08-22 星期四 -->
<template>
  <div class="food-class-list">
    <AppBar title="食物档案" :placeholder="true" :zIndex="10"> </AppBar>
    <div class="food-list">
      <scroll
        :data="foodList"
        :pullup="true"
        @pullup="pullup"
        ref="scroll"
        :probeType="3"
      >
        <template v-for="(item, index) in this.foodList">
          <div :key="index" class="food_wrap" @click="toDetails(item)">
            <div class="image">
              <img class="icon" :src="item.thumb_image_url" />
              <img
                class="flag"
                v-if="item.is_super"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/159a9ada5ca72d0571bd0c2464441200.png"
                alt=""
              />
            </div>
            <div class="f_w_info">
              <div class="w_i_wrap">
                <div class="i_w_name">{{ item.name }}</div>
                <div class="i_w_calory">{{ `${item.calory}千卡 / 100克` }}</div>
              </div>
            </div>
            <div class="f_w_right">
              <i class="iconfont icon-qianjin"></i>
            </div>
          </div>
        </template>
        <div v-if="!nextPage" class="no_more">没有更多了~</div>
      </scroll>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>

<script>
import AppBar from '@/components/app/nav-bar/index.vue'
import scroll from '@/components/scroll'
export default {
  name: 'calorie-query-class-list',
  mixins: [],
  components: { scroll, AppBar },
  props: {},
  data() {
    return {
      loaded: false,
      foodList: [],
      classid: this.$route.query.classid || '',
      page: 1, // 当前页
      pagesize: 100, // 每页显示数量
      nextPage: 1 // 上拉加载：判断标识
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},
  activated() {
    if (this.$refs.scroll) {
      this.$refs.scroll.refresh()
      this.$refs.scroll.scrollTo(0, this.top, 0)
    }
  },
  beforeRouteEnter(to, from, next) {
    document.title = to.query.name
    next((vm) => {
      console.log(from)
      // vm.$store.commit("setShowTabbar", false);
      let routeName = ['calorie-query-index', 'wegymer-dietician']
      if (routeName.includes(from.name)) {
        vm.classid = vm.$route.query.classid || ''
        vm.top = 0
        vm.page = 1
        vm.foodList = []
        vm.getDataTwo()
      }
    })
  },

  destroyed() {},

  methods: {
    // 具体食物种类的内容
    getDataTwo() {
      let params = {
        classifier: this.classid,
        page: this.page,
        limit: this.pagesize
      }
      this.$http
        .getApp('member/Foods/foodsList', params)
        .then((rs) => {
          if (rs.data.code === 200) {
            let result = rs.data.data
            this.foodList = this.foodList.concat(result)
            if (!result || !result.length) {
              this.nextPage = 0
            }
            this.page++
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.data.msg
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    // 上拉加载
    pullup(val) {
      if (!this.nextPage) {
        return false
      }
      this.getDataTwo()
    },
    // 跳转到食物详情页
    toDetails(val) {
      this.top = this.$refs['scroll'].scrollTop
      if (val.is_super) {
        this.$router.push({
          path: '/calorie-query/super-food-detail',
          query: { id: val.id, name: val.name }
        })
      } else {
        this.$router.push({
          name: 'calorie-query-food-info',
          query: { foodid: val.id, name: val.name }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.food-class-list {
  height: 100vh;
  background: #fff;
  padding: 0.1vw 4.9vw;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  .food-list {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }

  .food_wrap {
    display: flex;
    align-items: center;

    .image {
      position: relative;
      width: 12.8vw;
      height: 12.8vw;

      .icon {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .flag {
        width: 100%;
        position: absolute;
        left: 50%;
        bottom: 0%;
        transform: translate(-50%, 0%);
      }
    }

    .f_w_info {
      flex: 1;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4.3vw 0 4.3vw 4.3vw;
      box-sizing: border-box;
      color: #000000;
      border-bottom: 0.2vw solid #f5f5f5;
      overflow: hidden;

      .w_i_wrap {
        widows: 100%;
        text-align: left;
        overflow: hidden;

        .i_w_name {
          font-size: 4vw;
          font-weight: 600;
        }

        .i_w_calory {
          font-size: 3.2vw;
          margin-top: 2.1vw;
          color: rgba(0, 0, 0, 0.5);
        }
      }

      .w_i_light {
        font-size: 3.6vw;
        min-width: fit-content;
        margin-left: 4vw;
      }

      svg {
        min-width: 5.3vw;
        height: 5.1vw;
      }
    }

    .f_w_right {
      color: #666;
      font-size: 2.1vw;
    }
  }

  .no_more {
    text-align: center;
    margin: 4vw 0 0 0;
    color: #bbb;
    padding: 3.2vw 0;
    font-size: 2.93vw;
    // border-top: 0.13vw solid #bbb;
  }
}

.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
